<a id="btnDownload" class="d-none" href="javascript:void('');" download>DownloadFakeBtn</a>
<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <svg-icon src="assets/svg/child.svg"></svg-icon>
            <h1 class="page-title">{{'daycare.manutencao'|translate}}</h1>
        </div>

        <p class="daycare-hint">{{'daycare.manutencaoexplica'|translate}}</p>
        <p class="daycare-hint text-muted"><small>⚠️ {{'daycare.previewvolatil'|translate}}</small></p>

        <!-- Passo 1: unidade + baixar planilha atual + arquivo -->
        <div class="daycare-form">
            <div class="input-material" *ngIf="showUnitySelector">
                <select id="unity" [(ngModel)]="unityId" class="form-control">
                    <option [ngValue]="null" disabled>{{'daycare.selecioneunidade'|translate}}</option>
                    <option *ngFor="let u of unities" [ngValue]="u.id">{{u.name}}</option>
                </select>
                <label for="unity" class="mb-0 mr-3">{{'unidade'|translate}}</label>
            </div>

            <button type="button" class="btn btn-gray-fill" [disabled]="loading" (click)="downloadCurrent()">
                <svg-icon class="mr-1" src="assets/svg/downloads.svg"></svg-icon>{{'daycare.baixarplanilhaatual'|translate}}
            </button>

            <label class="btn btn-gray-fill mb-0">
                <svg-icon class="mr-1" src="assets/svg/downloads.svg"></svg-icon>
                <span>{{ fileName || ('daycare.selecionararquivo'|translate) }}</span>
                <input type="file" class="d-none"
                       accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       onclick="this.value=null"
                       (change)="onFileSelected($event)"/>
            </label>

            <button type="button" class="btn btn-primary text-white" [disabled]="loading" (click)="analyze()">
                {{'daycare.analisarplanilha'|translate}}
            </button>
        </div>

        <div *ngIf="loading" class="text-center my-4">{{'daycare.processando'|translate}}</div>

        <div *ngIf="preview && !loading" class="daycare-preview mt-4">

            <!-- CASO ERRO: planilha rejeitada, sem plano -->
            <ng-container *ngIf="preview.valid === false">
                <div class="alert alert-danger">
                    <strong>{{'daycare.planilhainvalida'|translate}}</strong>
                    <div><small>{{'daycare.planilhainvalidaexplica'|translate}}</small></div>
                </div>
                <div class="daycare-block" *ngFor="let type of errorTypes()">
                    <h5 class="text-danger">{{ ('daycare.errortype.' + type) | translate }}</h5>
                    <div class="table-responsive">
                        <table class="table table_regular">
                            <thead>
                            <tr>
                                <th>{{'daycare.linha'|translate}}</th>
                                <th>{{'daycare.coluna'|translate}}</th>
                                <th>{{'daycare.valor'|translate}}</th>
                                <th>{{'daycare.mensagem'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let e of errorsByType(type)" class="row-danger">
                                <td>{{ e.row || '—' }}</td>
                                <td>{{ e.column || '—' }}</td>
                                <td>{{ e.value || '—' }}</td>
                                <td>{{ e.message }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </ng-container>

            <!-- CASO VÁLIDO: plano dry-run -->
            <ng-container *ngIf="preview.valid === true">

                <!-- ALERTA CRÍTICO: remoção em massa -->
                <div *ngIf="preview.massDeletionWarning" class="alert alert-danger daycare-mass-alert">
                    <strong>⚠️ {{'daycare.massdeletiontitulo'|translate}}</strong>
                    <div>{{ ('daycare.massdeletioncorpo' | translate)
                        .replace('{count}', preview.counts?.delete || 0)
                        .replace('{percent}', preview.massDeletionPercent || 0) }}</div>
                    <div class="mt-1"><small>{{'daycare.massdeletioncausa'|translate}}</small></div>
                </div>

                <!-- Aviso: criança sem guardião -->
                <div *ngIf="preview.warnings?.length" class="alert alert-warning">
                    <strong>{{'daycare.avisosemguardiao'|translate}}</strong>
                    <ul class="mb-0">
                        <li *ngFor="let w of preview.warnings">{{ w.childName }} — {{ w.message }}</li>
                    </ul>
                </div>

                <!-- Resumo -->
                <div class="daycare-block">
                    <div class="daycare-totals">
                        <span class="text-success"><b>{{ preview.counts?.create || 0 }}</b> {{'daycare.aincluir'|translate}}</span>
                        <span class="text-warning"><b>{{ preview.counts?.update || 0 }}</b> {{'daycare.aalterar'|translate}}</span>
                        <span class="text-danger"><b>{{ preview.counts?.delete || 0 }}</b> {{'daycare.aremover'|translate}}</span>
                    </div>
                </div>

                <div *ngIf="!preview.counts?.create && !preview.counts?.update && !preview.counts?.delete"
                     class="alert alert-info">{{'daycare.nenhumamudanca'|translate}}</div>

                <!-- A INCLUIR -->
                <div class="daycare-block" *ngIf="preview.toCreate?.children?.length || preview.toCreate?.guardians?.length">
                    <h5 class="text-success">{{'daycare.aincluir'|translate}}</h5>
                    <ul>
                        <li *ngFor="let c of preview.toCreate.children">
                            {{'crianca'|translate}}: <b>{{ c.childName }}</b> (RE {{ c.employeeRe }}) — {{ c.guardiansCount }} {{'pessoasautorizadas'|translate}}
                        </li>
                        <li *ngFor="let g of preview.toCreate.guardians">
                            {{'pessoasautorizadas'|translate}}: <b>{{ g.name }}</b>
                            <span *ngIf="g.documentRaw">— {{ g.documentRaw }}</span>
                            <span class="badge badge-primary ml-1" *ngIf="g.kind === 'parent'">{{'paimae'|translate}}</span>
                        </li>
                    </ul>
                </div>

                <!-- A ALTERAR (de → para) -->
                <div class="daycare-block" *ngIf="preview.toUpdate?.length">
                    <h5 class="text-warning">{{'daycare.aalterar'|translate}}</h5>
                    <div class="table-responsive">
                        <table class="table table_regular">
                            <thead>
                            <tr>
                                <th>{{'daycare.registro'|translate}}</th>
                                <th>{{'daycare.campo'|translate}}</th>
                                <th>{{'daycare.de'|translate}}</th>
                                <th>{{'daycare.para'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let u of preview.toUpdate">
                                <td>{{ u.label }} <small class="text-muted">({{ u.type }})</small></td>
                                <td>{{ u.field }}</td>
                                <td class="text-muted">{{ u.from || '—' }}</td>
                                <td><b>{{ u.to || '—' }}</b></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- A REMOVER (destaque forte) -->
                <div class="daycare-block daycare-danger-block"
                     *ngIf="preview.toDelete?.children?.length || preview.toDelete?.guardians?.length">
                    <h5 class="text-danger">⚠️ {{'daycare.aremover'|translate}}</h5>
                    <p class="text-danger"><small>{{'daycare.aremoverexplica'|translate}}</small></p>
                    <ul>
                        <li *ngFor="let c of preview.toDelete.children" class="text-danger">
                            {{'crianca'|translate}}: <b>{{ c.name }}</b> (RE {{ c.employeeRe }})
                        </li>
                        <li *ngFor="let g of preview.toDelete.guardians" class="text-danger">
                            {{'pessoasautorizadas'|translate}}: <b>{{ g.name }}</b>
                            <span *ngIf="g.documentRaw">— {{ g.documentRaw }}</span>
                        </li>
                    </ul>
                </div>

                <!-- Confirmar -->
                <div class="text-right mt-3">
                    <button type="button" class="btn btn-primary btn-lg text-white" [disabled]="loading" (click)="confirmImport()">
                        {{'daycare.confirmarimportacao'|translate}}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
